import { css } from '@emotion/core'

export const getBorderStyle = (
  skipLeftRounding?: boolean,
  skipRightRounding?: boolean,
  fullRound?: boolean,
  borderRadius?: string,
) => css`
  border-radius: ${fullRound ? '50%' : borderRadius};

  ${skipLeftRounding &&
  css`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  `}

  ${skipRightRounding &&
  css`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `}
`
